module.exports = __webpack_public_path__ + "img/Wynk-logo.7ecdb145.png";